import { render, staticRenderFns } from "./service-agree.modal.vue?vue&type=template&id=58cdb684&"
import script from "./service-agree.modal.vue?vue&type=script&lang=ts&"
export * from "./service-agree.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports